import { supabase } from '@/integrations/supabase/client';
import { createNotificationIfEnabled, type DispatchNotificationInput } from '@/lib/notificationPreferences';

interface PushNotificationPayload {
  userId: string;
  type?: string;
  title?: string;
  body: string;
  url?: string;
  entityType?: string;
  entityId?: string;
}

export const sendPushNotification = async ({
  userId,
  type,
  title = 'Kindred',
  body,
  url,
  entityType,
  entityId,
}: PushNotificationPayload) => {
  const { error } = await supabase.functions.invoke('send-push-notification', {
    body: {
      user_id: userId,
      type,
      title,
      body,
      url,
      entity_type: entityType,
      entity_id: entityId,
    },
  });

  if (error) {
    console.warn('Could not send push notification', error);
  }
};

export const dispatchNotification = async ({
  userId,
  type,
  title,
  body,
  url,
  entityType,
  entityId,
}: DispatchNotificationInput) => {
  try {
    const { error } = await createNotificationIfEnabled({
      userId,
      type,
      body,
      entityType,
      entityId,
      title,
      url,
    });
    if (error) {
      console.warn('Could not create notification', error);
    }
  } catch (error) {
    console.warn('Could not create notification', error);
  }

  try {
    await sendPushNotification({
      userId,
      type,
      title,
      body,
      url,
      entityType,
      entityId,
    });
  } catch (error) {
    console.warn('Could not dispatch push notification', error);
  }
};
